import { type StreamResponse } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { type StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const createStoreAssistantWithContent = (content: StreamResponse): StoreAssistant => ({
	type: 'ASSISTANT',
	content,
});
